const { __ } = wp.i18n;
export default [
  {
    value: "none",
    label: __("None", "uipress-lite"),
  },
  {
    value: "top left",
    label: __("Top left", "uipress-lite"),
  },
  {
    value: "top center",
    label: __("Top center", "uipress-lite"),
  },
  {
    value: "top right",
    label: __("Top right", "uipress-lite"),
  },
  ///
  {
    value: "center left",
    label: __("Center left", "uipress-lite"),
  },
  {
    value: "center center",
    label: __("Center center", "uipress-lite"),
  },
  {
    value: "center right",
    label: __("Center right", "uipress-lite"),
  },
  ///
  {
    value: "bottom left",
    label: __("Bottom left", "uipress-lite"),
  },
  {
    value: "bottom center",
    label: __("Bottom center", "uipress-lite"),
  },
  {
    value: "bottom right",
    label: __("Bottom right", "uipress-lite"),
  },
];
